// Password managers (Bitwarden/Vaultwarden, 1Password, LastPass) offer logins
// on every input field they find - in xControl most fields are no logins
// (Martin, 2026-10-28: "außer bei tatsächlich echten Passwortfeldern"). Every
// field is marked to be ignored except password fields and the user fields
// that belong to a login (autocomplete="username"); new fields are marked as
// they appear.

const ignore = ['data-bwignore', 'data-1p-ignore', 'data-lpignore']

// isLoginField: a field a password manager may fill.
export function isLoginField(el: Element): boolean {
  if (!(el instanceof HTMLInputElement)) return false
  const ac = (el.getAttribute('autocomplete') || '').toLowerCase()
  return el.type === 'password' || ac.includes('username') || ac.includes('password')
}

function mark(el: Element) {
  if (isLoginField(el)) {
    for (const a of ignore) if (el.getAttribute(a) === 'true') el.removeAttribute(a)
    return
  }
  for (const a of ignore) if (!el.hasAttribute(a)) el.setAttribute(a, 'true')
}

const fields = 'input, textarea, select'

export function keepPasswordManagersToLogins(root: HTMLElement = document.body) {
  root.querySelectorAll(fields).forEach(mark)
  new MutationObserver((changes) => {
    for (const c of changes) {
      if (c.type === 'attributes') {
        mark(c.target as Element)
        continue
      }
      c.addedNodes.forEach((n) => {
        if (!(n instanceof Element)) return
        if (n.matches(fields)) mark(n)
        n.querySelectorAll(fields).forEach(mark)
      })
    }
  }).observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['type', 'autocomplete'] })
}
